export default __webpack_public_path__ + "1a137aaa6b1b7177a36e2af0b8f102db.png";